import { render, staticRenderFns } from "./SafetySingle.vue?vue&type=template&id=00cf88e8&scoped=true&"
import script from "./SafetySingle.vue?vue&type=script&lang=js&"
export * from "./SafetySingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cf88e8",
  null
  
)

export default component.exports